import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const PurchaseEditView = React.lazy(() => import('@/modules/purchase/components/edit/purchase-edit-view'))
const PurchaseDetail = React.lazy(() => import('@/modules/purchase/components/detail/purchase-detail'))
const TransactionSendEmail = React.lazy(() => import('@/modules/transaction/components/email/transaction-send-email'))
const PurchaseList = React.lazy(() => import('@/modules/purchase/components/list/purchase-list'))

const purchaseRoutes = (
  <>
    <Route path='purchase/*' element={<RedirectToPlural />} />
    <Route path='purchases' Component={PurchaseList} handle={{ title: 'Bestellungen', options: { noBackgroundColor: true } }} />
    <Route path='purchases/new' Component={PurchaseEditView} />
    <Route path='purchases/edit/:id' Component={PurchaseEditView} />
    <Route path='purchases/new/supplier/:supplierId' Component={PurchaseEditView} />
    <Route path='purchases/:id' Component={PurchaseDetail} />
    <Route path='purchases/send/:id' Component={TransactionSendEmail} handle={{ options: { noBackgroundColor: true } }} />
  </>
)

export default purchaseRoutes
